import { render } from "./LiveNow.vue?vue&type=template&id=635de7b9&scoped=true"
import script from "./LiveNow.vue?vue&type=script&lang=js"
export * from "./LiveNow.vue?vue&type=script&lang=js"

import "./LiveNow.vue?vue&type=style&index=0&id=635de7b9&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635de7b9"]])

export default __exports__